import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { OpenedStores } from './OpenedStores';
const StoreNearbyStores = ({ openedStores }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    return (_jsx(OpenedStores, { openedStores: openedStores, copy: { title: t('store.nearbystores.txt'), button: t('store.details.txt') } }));
};
export default StoreNearbyStores;
